import React from 'react';
import { WsBaseAddress } from '../../../ws/result/WsBaseAddress';
import { WsAddress } from '../../../ws/result/WsAddress';
import { AddressBox } from './AddressBox';
import { WsPackstation } from '../../../ws/result/WsPackstation';
import { Packstation } from './Packstation';

export type AddressViewProps = { address: WsBaseAddress };

// TODO(VL): Use Addresses from checkout (export new package for common address foo
export const AddressView: React.FC<AddressViewProps> = ({ address }) => {
    if (address instanceof WsAddress) {
        return <AddressBox address={address} />;
    } else if (address instanceof WsPackstation) {
        return <Packstation address={address} />;
    } else {
        // Explicit type check needed to get flow happy
        // If anything else is encountered here we ignore it.
        return null;
    }
};
